import React from "react";
import { Row, Col } from "antd";
import logo from "../../../_assets/images/sky-logo.png";
import "./Header.scss";

const Header = () => {
  return (
    <header className="site-header">
      <Row justify="center" align="middle">
        <Col>
          <div className="logo-container">
            <img src={logo} alt="Sky Auto Finance" className="logo" />
          </div>
        </Col>
      </Row>
    </header>
  );
};

export default Header;
